module.exports = __webpack_public_path__ + "img/paytype-bottom.358a3763.png";